import React, { useEffect, useRef, useState } from "react";

export function ProfileScore({ score }: any) {
    let style = {};

    if (score >= 100) {
        style = {
            color: '#0B6B1D',
            background: 'rgba(58, 161, 78, 0.10)'
        };
    } else if (score >= 70 && score < 100) {
        style = {
            color: '#5E5873',

            borderRadius: '8px',
            background: 'rgba(94, 88, 115, 0.10)'
        }


    }

    return (
        <div className="profile-score" style={style}>
            Profile Score: <span>{score}%</span>
        </div>
    );
};

